import { render, staticRenderFns } from "./ModalTransferencia.vue?vue&type=template&id=81a9226e&scoped=true&"
import script from "./ModalTransferencia.vue?vue&type=script&lang=js&"
export * from "./ModalTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./ModalTransferencia.vue?vue&type=style&index=0&id=81a9226e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a9226e",
  null
  
)

export default component.exports